// Function to initialize city select for hotel forms using unique selectors
function initializeHotelCitySelect() {
  let selectedRegion = $('#hotel-prefecture-select').val();
  let citySelect = $('#hotel-city-select');
  let cityVal = citySelect.data("city");
  
  if (selectedRegion && citySelect.length) {
    $.ajax({
      url: '/prefectures_with_cities.json',
      method: 'GET',
      dataType: 'json',
      success: function (regionsWithCities) {
        let cities = regionsWithCities[selectedRegion] || [];

        citySelect.empty();
        citySelect.append($('<option>', { value: '', text: '市町村を選択' }));

        let found = false;

        $.each(cities, function (index, city) {
          let option = $('<option>', { value: city, text: city });

          if (cityVal !== undefined && cityVal === city) {
            option.prop('selected', true);
            found = true;
          }
          
          citySelect.append(option);
        });
        if (cityVal !== undefined && !found) {
          citySelect.append($('<option>', { value: cityVal, text: cityVal, selected: "selected" }));
        }
        console.log('City select initialized');
      },
      error: function () {
        console.log('Error fetching regions with cities.');
      }
    });
  }
}

$(document).on('turbolinks:load', function () {
  initializeHotelCitySelect();

    $('.date-picker').change(function () {
      $('.filter-form').submit();
    });

  // Xóa event handler cũ để tránh conflict
  // $('#profile_image_file_input').change(function (e) {
  //   fileInput = $('#profile_image_file_input');
  //   var files = fileInput[0].files;
  //   $('.hotel-profile').text("");
  //   $('.hotel-profile').text(files[0].name);
  //   $('.error-hotel-profile-image').addClass('d-none');
  // })

  var imagesPreview = function (input, placeToInsertImagePreview) {
    if (input.files.length < 6) {
      placeToInsertImagePreview.empty()
      var filesAmount = input.files.length;
      for (i = 0; i < filesAmount; i++) {
        var reader = new FileReader();

        reader.onload = function (event) {
          let htmlImagePreview = `<div>
                      <img src="${event.target.result}" style="width: 140px; height: 140px;" class="aspect-1 mobject-fit">
                    </div>`
          $(htmlImagePreview).appendTo(placeToInsertImagePreview);
        }
        reader.readAsDataURL(input.files[i]);
      }
    }
  }


  // Xóa event handler cũ để tránh conflict với event handler mới
  // $(document).on('change', '#profile_image_file_input', function () {
  //   const file = this.files[0];
  //   if (file) {
  //     const maxSize = 10 * 1024 * 1024; // 10MB in bytes

  //     if (file.size > maxSize) {
  //       $('body').append(`
  //       <div class="modal fade" id="image_modal" data-bs-backdrop="true" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  //         <div class="modal-dialog modal-lg modal-dialog-centered">
  //           <div class="modal-content">
  //             <div class="modal-header">
  //               <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
  //             </div>
  //             <div class="modal-body">
  //               <div class="content-madal-text d-flex justify-content-center fw-bold px-3">
  //                 画像は10MBサイズ以下でアップお願いします。
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     `)
  //     $('#image_modal').show();
  //     $('#image_modal').addClass('show')
  //     $(document).on('click', '#image_modal button', function () {
  //       $('#image_modal').remove();
  //     })
  //       this.value = '';
  //       $('.hotel-profile').text("※最大10MBまでアップできます。");
  //       $('.hotel-image-preview').find('img').attr('src', '');
  //       $('.hotel-image-preview').find('img').attr('style', '');
  //       return
  //     }
  //   }
  //   imagesPreview(this, $('.hotel-image-preview'));
  //   $('.error-hotel-images').addClass('d-none');
  // });

  // Auto hide errors when user interacts with fields
  $('#hotel_name').on('input focus click', function () {
    $('.error-hotel-name').addClass('d-none');
    $(this).removeClass('invalid');
  });

  $('#hotel_phone_number').on('input focus click', function () {
    $('.error-hotel-phone-number').addClass('d-none');
    $(this).removeClass('invalid');
  });

  $('#hotel_email').on('input focus click', function () {
    $('.error-hotel-email').addClass('d-none');
    $('.error-hotel-email-syntax').addClass('d-none');
    $(this).removeClass('invalid');
  });

  $('#hotel-prefecture-select').on('change', function () {
    var selectedRegion = $(this).val();
    var citySelect = $('#hotel-city-select');
    
    if (selectedRegion) {
      $.ajax({
        url: '/prefectures_with_cities.json',
        method: 'GET',
        dataType: 'json',
        success: function (regionsWithCities) {
          var cities = regionsWithCities[selectedRegion] || [];
          citySelect.append($('<option>', {value: '', text: '市町村を選択'}));
          $.each(cities, function (index, city) {
            citySelect.append($('<option>', {value: city, text: city}));
          });
        },
        error: function () {
          console.log('Error fetching regions with cities.');
        }
      });
    }
  });

  $('#hotel-prefecture-select, #hotel-city-select').on('change focus click', function () {
    $('.error-hotel-location').addClass('d-none');
    $(this).removeClass('invalid');
  });

  $('#hotel_addition_location').on('input focus click', function () {
    $('.error-hotel-location').addClass('d-none');
    $(this).removeClass('invalid');
  });

  $('#hotel_start_time, #hotel_end_time').on('change focus click', function () {
    $('.error-hotel-time').addClass('d-none');
    $(this).removeClass('invalid');
  });

  $('#hotel_note').on('input focus click', function () {
    $('.error-hotel-note').addClass('d-none');
    $(this).removeClass('invalid');
  });

  $('#hotel_year, #hotel_month, #hotel_day').on('change focus click', function () {
    $('.error-hotel-start-day').addClass('d-none');
    $(this).removeClass('invalid');
  });

  // Auto hide errors for checkboxes
  $('.hotel-pet-category input[type="checkbox"]').on('change click', function (e) {
    e.stopPropagation();
    $('.error-hotel-pet-category').addClass('d-none');
    $(this).closest('.hotel-pet-category').removeClass('invalid');
  });

  $('.hotel-services input[type="checkbox"]').on('change click', function (e) {
    e.stopPropagation();
    $('.error-hotel-service').addClass('d-none');
    $(this).closest('.hotel-services').removeClass('invalid');
  });

  $('.access-checkbox input[type="checkbox"]').on('change click', function (e) {
    e.stopPropagation();
    $('.error-hotel-access').addClass('d-none');
    $(this).closest('.access-checkbox').removeClass('invalid');
  });

  $('.hotel-none-working-day input[type="checkbox"]').on('change click', function (e) {
    e.stopPropagation();
    $('.error-hotel-none-working-day').addClass('d-none');
    $(this).closest('.hotel-none-working-day').removeClass('invalid');
  });

  $('.hotel-discount input[type="checkbox"]').on('change click', function (e) {
    e.stopPropagation();
    // Discount sử dụng error-hotel-service trong view
    $('.error-hotel-discount').addClass('d-none');
    $(this).closest('.hotel-discount').removeClass('invalid');
  });

  // Auto hide errors for file inputs
  $('#profile_image_file_input').on('change focus click', function (e) {
    e.stopPropagation();
    
    // Preview image
    if (this.files && this.files[0]) {
      const file = this.files[0];
      const maxSize = 10 * 1024 * 1024; // 10MB in bytes
      
      // Check file size
      if (file.size > maxSize) {
        $('body').append(`
        <div class="modal fade" id="image_modal" data-bs-backdrop="true" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
          <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <div class="content-madal-text d-flex justify-content-center fw-bold px-3">
                  画像は10MBサイズ以下でアップお願いします。
                </div>
              </div>
            </div>
          </div>
        </div>
      `)
        $('#image_modal').show();
        $('#image_modal').addClass('show')
        $(document).on('click', '#image_modal button', function () {
          $('#image_modal').remove();
        })
        this.value = '';
        $('.hotel-profile').text("※最大10MBまでアップできます。");
        $('.hotel-image-preview').find('img').attr('src', '');
        $('.hotel-image-preview').find('img').attr('style', '');
        return
      }
      
      // Update file name
      $('.hotel-profile').text("");
      $('.hotel-profile').text(file.name);
      
      // Preview image
      imagesPreview(this, $('.hotel-image-preview'));
    }
    
    // Hide error
    $('.error-hotel-profile-image').addClass('d-none');
    $(this).removeClass('invalid');
  });

  // Chỉ áp dụng cho input-file không phải profile image
  $('.input-file:not(#profile_image_file_input)').on('change focus click', function (e) {
    e.stopPropagation();
    // Chỉ ẩn error của hotel images, không ảnh hưởng đến profile image
    $('.error-hotel-images').addClass('d-none');
    $(this).removeClass('invalid');
  });

  $('#hotel_year, #hotel_month').change(function () {
    var year = $('#hotel_year').val();
    var month = $('#hotel_month').val();
    var daysInMonth = new Date(year, month, 0).getDate();

    $('#hotel_day').empty();
    for (var i = 1; i <= daysInMonth; i++) {
      $('#hotel_day').append($('<option>', {
        value: i,
        text: i
      }));
    }
  });

  function getSelectedTextAsString(selector) {
    return $(selector).siblings('label').map(function () {
      return $(this).text();
    }).get().join(',  ');
  }

  var dayMap = {
    '0': '日',
    '1': '月',
    '2': '火',
    '3': '水',
    '4': '木',
    '5': '金',
    '6': '土'
  };

  var categoryMap = {
    '0': '小型犬',
    '1': '中型犬',
    '2': '大型犬',
    '3': '猫',
    '4': '小動物'
  };

  $(".form-check-input").on("change", function() {
    var index = $(this).data("index");
    var additionalInfo = $(`#additional-info-${index}`);
    
    if ($(this).is(":checked")) {
      additionalInfo.show();
      $(`.rate-all-time-${parseInt(index) + 1}`).removeClass("d-none");
      $(`.rate-part-time-${parseInt(index) + 1}`).removeClass("d-none");
    } else {
      additionalInfo.hide();
      $(`.rate-all-time-${parseInt(index) + 1}`).addClass("d-none");
      $(`.rate-part-time-${parseInt(index) + 1}`).addClass("d-none");
    }
  });

  $(".btn-submit-hotel").on("click", function () {

    $(".form-check-input").each(function() {
      var index = $(this).data("index");

      if ($(this).is(":checked")) {
        var rateAllTime = $(`input[name='hotel[hotel_subcategory_pricings_attributes][${index}][rate_all_time]']`).val();
        var ratePartTime = $(`input[name='hotel[hotel_subcategory_pricings_attributes][${index}][rate_part_time]']`).val();

        if (!rateAllTime && !ratePartTime) {
          $(`.rate-all-time-${parseInt(index) + 1}`).removeClass("d-none");
          $(`.rate-part-time-${parseInt(index) + 1}`).removeClass("d-none");
        } else {
          $(`.rate-all-time-${parseInt(index) + 1}`).addClass("d-none");
          $(`.rate-part-time-${parseInt(index) + 1}`).addClass("d-none");
        }
      }
    });

    $('.d-none input[type="number"]').removeAttr('required');
    $('.d-none input[type="number"]').prop('required', false);

    function showError(element, errorClass) {
      $(element).addClass('invalid');
      errorClass.removeClass('d-none');
      hasError = true;
      
      if (!firstErrorElement && $(element).length) {
        firstErrorElement = element;
      }
    }

    function hideError(element, errorClass) {
      $(element).removeClass('invalid');
      errorClass.addClass('d-none');
    }

    function validateInput(input, errorClass) {
      if ($(input).val()) {
        hideError(input, errorClass);
        return false;
      } else {
        showError(input, errorClass);
        return true;
      }
    }

    function validatePhoneNumber(phoneNumberElement, errorElement) {
      if (!/^\d{10,11}$/.test(phoneNumberElement.val())) {
        phoneNumberElement.addClass('invalid');
        errorElement.removeClass('d-none');
        hasError = true

        if (!firstErrorElement && $(phoneNumberElement).length) { 
          firstErrorElement = phoneNumberElement;
        }

        return true;
      } else {
        phoneNumberElement.removeClass('invalid');
        errorElement.addClass('d-none');

        return false;
      }
    }

    function validateCheckboxGroup(group, errorClass) {
      if (group.length === 0) {
        errorClass.removeClass('d-none');
        hasError = true;
      } else {
        errorClass.addClass('d-none');
      }
    }

    // var profileImage = $('#profile_image_file_input')[0].files.length;
    var name = $('#hotel_name').val();
    var prefecture = $('#hotel-prefecture-select').val();
    var city = $('#hotel-city-select').val();
    var additionLocation = $('#hotel_addition_location').val();
    var phoneNumber = $('#hotel_phone_number').val();
    var email = $('#hotel_email').val();
    var emailPattern = /^([a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)$/
    var errorElement = $('.error-hotel-email-syntax');
    var startTime = $('#hotel_start_time').val();
    var endTime = $('#hotel_end_time').val();
    var note = $('#hotel_note').val();
    var year = $('#hotel_year').val();
    var month = $('#hotel_month').val();
    var day = $('#hotel_day').val();
    var hasError = false;
    var firstErrorElement = null;
    var petCategory = $('.hotel-pet-category input[type="checkbox"]:checked');
    var hotelServices = $('.hotel-services input[type="checkbox"]:checked');
    var hotelDiscount = $('.hotel-discount input[type="checkbox"]:checked');
    var accessCheckbox = $('.access-checkbox input[type="checkbox"]:checked');
    var hotelNoneWorkingDay = $('.hotel-none-working-day input[type="checkbox"]:checked');
    var startDay = $('#hotel_start_day').val();
    var endDay = $('#hotel_end_day').val();
    var hotelPayments = $('.hotel-payments input[type="checkbox"]:checked');
    // Kiểm tra xem có ảnh cũ không bằng cách kiểm tra src của img
    var hasExistingProfileImage = $('.hotel-image-preview img').attr('src') && 
                                 $('.hotel-image-preview img').attr('src') !== '' &&
                                 !$('.hotel-image-preview img').attr('src').includes('image_base.png');
    
    var hasExistingHotelImages = false;
    $('.answer-image-preview img').each(function() {
      if ($(this).attr('src') && $(this).attr('src') !== '') {
        hasExistingHotelImages = true;
        return false; // break loop
      }
    });

    // Validation cho ảnh profile - tách biệt hoàn toàn
    var profileImage = $('#profile_image_file_input')[0].files.length;
    if (!hasExistingProfileImage && profileImage === 0) {
      showError($('#profile_image_file_input'), $('.error-hotel-profile-image'));
      hasError = true;
    } else {
      // Chỉ ẩn error profile image, không ảnh hưởng đến hotel images
      $('.error-hotel-profile-image').addClass('d-none');
      $('#profile_image_file_input').removeClass('invalid');
    }

    // Validation cho ảnh multiple - tách biệt hoàn toàn
    var hasAnyImage = false;
    // Chỉ kiểm tra hotel images, không bao gồm profile image
    $(".input-file:not(#profile_image_file_input)").each(function () {
      if ($(this).get(0).files.length > 0) {
        hasAnyImage = true;
      }
    });

    if (!hasExistingHotelImages && !hasAnyImage) {
      showError($(".input-file:not(#profile_image_file_input)").first(), $('.error-hotel-images'));
      hasError = true;
    } else {
      $('.error-hotel-images').addClass('d-none');
      $(".input-file:not(#profile_image_file_input)").removeClass('invalid');
    }

    hasError |= validateInput('#hotel_name', $('.error-hotel-name'));
    hasError |= validateInput('#hotel-prefecture-select', $('.error-hotel-location'));
    hasError |= validateInput('#hotel-city-select', $('.error-hotel-location'));
    hasError |= validateInput('#hotel_addition_location', $('.error-hotel-location'));
    hasError |= validatePhoneNumber($('#hotel_phone_number'), $('.error-hotel-phone-number'));

    if (!email) {
      showError($('#hotel_email'), $('.error-hotel-email'));
      errorElement.addClass('d-none');
    } else {
      $('.error-hotel-email').addClass('d-none');
      if (emailPattern.test(email)) {
        errorElement.addClass('d-none');
      } else {
        showError($('#hotel_email'), errorElement);
      }
    }

    validateCheckboxGroup(petCategory, $('.error-hotel-pet-category'));
    validateCheckboxGroup(hotelServices, $('.error-hotel-service'));
    validateCheckboxGroup(hotelDiscount, $('.error-hotel-discount'));
    validateCheckboxGroup(accessCheckbox, $('.error-hotel-access'));

    // Validate pricing fields only for checked categories that are visible
    $(".form-check-input:checked").each(function() {
      var index = $(this).data("index");
      var rateAllTimeField = $(`input[name='hotel[hotel_subcategory_pricings_attributes][${index}][rate_all_time]']`);
      var ratePartTimeField = $(`input[name='hotel[hotel_subcategory_pricings_attributes][${index}][rate_part_time]']`);
      
      if (!rateAllTimeField.closest('.d-none').length && rateAllTimeField.val() === '') {
        showError(rateAllTimeField, $(`.rate-all-time-${parseInt(index) + 1}`));
        hasError = true;
      }
      
      if (!ratePartTimeField.closest('.d-none').length && ratePartTimeField.val() === '') {
        showError(ratePartTimeField, $(`.rate-part-time-${parseInt(index) + 1}`));
        hasError = true;
      }
    });

    hasError |= validateInput('#hotel_start_time', $('.error-hotel-time'));
    hasError |= validateInput('#hotel_end_time', $('.error-hotel-time'));

    validateCheckboxGroup(hotelNoneWorkingDay, $('.error-hotel-none-working-day'));

    hasError |= validateInput('#hotel_note', $('.error-hotel-note'));
    hasError |= validateInput('#hotel_year', $('.error-hotel-start-day'));
    hasError |= validateInput('#hotel_month', $('.error-hotel-start-day'));
    hasError |= validateInput('#hotel_day', $('.error-hotel-start-day'));

    if (hasError && firstErrorElement) {
      $('html, body').animate({
        scrollTop: $(firstErrorElement).offset().top - 100
      }, 500);
    }

    if (!hasError) {
      $('.create-hotel').addClass('d-none');
      $('.preview-hotel').removeClass('d-none');
      $('.hotel-preview-name').text(name);
      $('.hotel-preview-per').text(prefecture);
      $('.hotel-preview-city').text(city);
      $('.hotel-preview-addition-location').text(additionLocation);
      $('.hotel-preview-phone-number').text(phoneNumber);
      $('.hotel-preview-email').text(email);
      // $('.hotel-preview-pet-category').text(getSelectedTextAsString(petCategory));
      $('.hotel-preview-services').text(getSelectedTextAsString(hotelServices));
      $('.hotel-preview-discount').text(getSelectedTextAsString(hotelDiscount));
      $('.hotel-preview-access').text(getSelectedTextAsString(accessCheckbox));
      $('.hotel-preview-none-working-day').text(getSelectedTextAsString(hotelNoneWorkingDay));
      $('.hotel-preview-date_time').text(dayMap[startDay] + '  ~  ' + dayMap[endDay] + '     ' + startTime + '~' + endTime);
      $('.hotel-preview-payments').text(getSelectedTextAsString(hotelPayments));
      $('.hotel-preview-contact-url').text($('#hotel_contact_url').val());
      $('.hotel-preview-homepage-url').text($('#hotel_home_page_url').val());
      $('.hotel-preview-reservation-url').text($('#hotel_reservation_url').val());
      $('.hotel-preview-publication-date').text(year + '年  ' + month + '月  ' + day + '日');
      $('.hotel-preview-note').css('white-space', 'pre-wrap').css('word-wrap', 'break-word').text(note);
      if ($('.hotel-preview-payments').text() === "") {
        $('.hotel-preview-payments-show').addClass('d-none');
      }
      if ($('.hotel-preview-contact-url').text() === "") {
        $('.hotel-preview-contact-url-show').addClass('d-none');
      }
      if ($('.hotel-preview-reservation-url').text() === "") {
        $('.hotel-preview-reservation-url-show').addClass('d-none');
      }
      if ($('.hotel-preview-contact-url').text() === "") {
        $('.hotel-preview-contact-url-show').addClass('d-none');
      }
      $("#preview-container").html("");

      $(".form-check-input:checked").each(function() {
        var index = $(this).data("index");

        var rateAllTime = $(`input[name='hotel[hotel_subcategory_pricings_attributes][${index}][rate_all_time]']`).val();
        var ratePartTime = $(`input[name='hotel[hotel_subcategory_pricings_attributes][${index}][rate_part_time]']`).val();
        var hours = $(`#hotel_hotel_subcategory_pricings_attributes_${index}_hours`).val();

        if (rateAllTime || ratePartTime) {
          var previewContent = `<div id="preview-category-${index} hotel-preview-title">
                                <div class="fs_18 hotel-preview-title pt-2">${categoryMap[index]}</div>
                                <div class="hotel-preview-title pt-1">宿泊</div>
                                <div class="hotel-preview-title">値段: ${rateAllTime || "0"}</div>
                                <div class="hotel-preview-title pt-1">一時預かり</div>
                                <div class="hotel-preview-title d-flex gap-3">時間: ${hours || "0"}    値段: ${ratePartTime || "0"}</div>
                              </div>`;

          $("#preview-container").append(previewContent);
        }
      });
    }
  });


  $(".btn-back-hotel").on("click", function () {
    $('.preview-hotel').addClass('d-none');
    $('.create-hotel').removeClass('d-none');
  });

  $('#openModalButton').on('click', function () {
    $.ajax({
      url: '/owners/hotels/destroy',
      type: 'GET'
    });
  });

  $('.modal-destroy-hotel').on('click', function (e) {
    var id = $(this).data('id');
    var owner_id = $(this).data('owner');
    var name = $(this).data('modal');

    if (name == 'Hotel') {
      $.ajax({
        url: $(this).data('delete-url'),
        method: "DELETE",
        data: {id: id, owner_id: owner_id},
        dataType: "json",
        success: function (response) {
          if (response.success) {
            $('#staticBackdrop-' + id).hide();
            $('#staticBackdrop-' + id).removeClass('show');
            $('#staticBackdrop-' + id).removeAttr('style');
            $('#myModal').addClass('show');
            $('#myModal').show();
          } else {
            window.location.reload();
          }
        },
        error: function (xhr) {
          window.location.reload();
        },
      });
    } else {
      $.ajax({
        url: $(this).data('delete-url'),
        method: "DELETE",
        data: {id: id, owner_id: owner_id},
        dataType: "json",
        success: function (response) {
          if (response.success) {
            $('#staticBackdrop-' + id).hide();
            $('#staticBackdrop-' + id).removeClass('show');
            $('#staticBackdrop-' + id).removeAttr('style');
            $('#myModal').addClass('show');
            $('#myModal').show();
          } else {
            window.location.reload();
          }
        },
        error: function (xhr) {
          window.location.reload();
        },
      });
    }
  });

  $('.modal-admin-destroy-hotel').on('click', function (e) {
    var id = $(this).data('id');
    var owner_id = $(this).data('owner');
    var name = $(this).data('modal');
    console.log(id, owner_id, name);

    if (name == 'Hotel') {
      $.ajax({
        url: "/admin/hotels/" + id,
        method: "DELETE",
        data: {id: id, owner_id: owner_id},
        dataType: "json",
        success: function (response) {
          if (response.success) {
            $('#staticBackdrop-' + id).hide();
            $('#staticBackdrop-' + id).removeClass('show');
            $('#staticBackdrop-' + id).removeAttr('style');
            $('#myModal').addClass('show');
            $('#myModal').show();
          } else {
            window.location.reload();
          }
        },
        error: function (xhr) {
          window.location.reload();
        },
      });
    } else {
      $.ajax({
        url: "/admin/hospitals/" + id,
        method: "DELETE",
        data: {id: id, owner_id: owner_id},
        dataType: "json",
        success: function (response) {
          if (response.success) {
            $('#staticBackdrop-' + id).hide();
            $('#staticBackdrop-' + id).removeClass('show');
            $('#staticBackdrop-' + id).removeAttr('style');
            $('#myModal').addClass('show');
            $('#myModal').show();
          } else {
            window.location.reload();
          }
        },
        error: function (xhr) {
          window.location.reload();
        },
      });
    }
    });

  $('.close-modal').on('click', function () {
    $('#myModal').removeClass('show');
    $('#myModal').show();
    $('#myModal').removeAttr('style');
  });

  function truncateText() {
    $('.element-name').each(function () {
      var text = $(this).data('original-text') || $(this).text().trim();

      if ($(window).width() < 768) {
        if (text.length > 13) {
          var newText = text.slice(0, 13) + '\n' + text.slice(10);
          $(this).text(newText);
        }
      } else {
        $(this).text(text);
      }

      $(this).data('original-text', text);
    });
  }

  truncateText();

  $(window).resize(function () {
    truncateText();
  });
});
